export default __webpack_public_path__ + "static/media/logoDark.7c2bddc0.svg";